import { z } from 'zod';
export const ENROLL_POLICY_TRIGGER_KINDS = ['inbound_request', 'lead_created'];
export const enrollPolicyConditionsSchema = z.object({
    max_spam_score: z.number().min(0).max(100).optional(),
    source_codes: z.array(z.string().min(1).max(64)).optional(),
    skip_if_tags: z.array(z.string().min(1).max(64)).optional(),
});
export const enrollPolicyCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(120),
    enabled: z.boolean().optional(),
    priority: z.number().int().min(0).max(1000).optional(),
    trigger_kind: z.enum(ENROLL_POLICY_TRIGGER_KINDS),
    conditions: enrollPolicyConditionsSchema.optional(),
    campaign_id: z.string().uuid().optional(),
    campaign_name: z.string().min(1).max(200).optional(),
}).superRefine((body, ctx) => {
    if (!body.campaign_id && !body.campaign_name?.trim()) {
        ctx.addIssue({
            code: 'custom',
            message: 'campaign_id or campaign_name required',
            path: ['campaign_id'],
        });
    }
});
export const enrollPolicyUpdateSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    enabled: z.boolean().optional(),
    priority: z.number().int().min(0).max(1000).optional(),
    trigger_kind: z.enum(ENROLL_POLICY_TRIGGER_KINDS).optional(),
    conditions: enrollPolicyConditionsSchema.optional(),
    campaign_id: z.string().uuid().nullable().optional(),
    campaign_name: z.string().min(1).max(200).nullable().optional(),
});
export const enrollPoliciesListQuerySchema = z.object({
    project_id: z.string().uuid(),
});
export const enrollPolicySimulateSchema = z.object({
    project_id: z.string().uuid(),
    lead_id: z.string().uuid(),
    trigger_kind: z.enum(ENROLL_POLICY_TRIGGER_KINDS).default('inbound_request'),
    spam_score: z.number().min(0).max(100).optional(),
    source_code: z.string().max(64).nullable().optional(),
});
//# sourceMappingURL=enrollPolicy.js.map